// import $ from 'jquery'

function onAccept() {
  // $('#legal-info').hide()
  const container = document.getElementById("legal-info")
  if (!container) {
    return false
  }
  container.style.display = "none"

  document.cookie = "_legalinfo=true; path=/; max-age=2592000;"
  document.body.style.marginBottom = "0px"

  return false
}

const classes = {
  container: "fixed bottom-0 bg-gray-800 text-white z-50 w-full py-6 px-4",
  containerInner: "container mx-auto print:none",
  flex: "md:flex items-center",
  left: "mb-4 md:mb-0 text-sm font-light",
  right: "flex-shrink-0 md:w-48 md:text-right ",
  link: "underline hover:text-gray",
  button:
    "px-4 py-2 text-center bg-gray-600 text-white rounded  cursor-pointer hover:bg-gray-700",
}

export function setupLegalPolicy(cookiePolicyUrl: string) {
  console.log("setupLegalPolicy", cookiePolicyUrl)
  var text =
    "Strona korzysta z plików cookies w celu realizacji usług i zgodnie z " +
    ` <a class="${classes.link}" target="_blank" href="` +
    cookiePolicyUrl +
    '">Polityką Plików Cookies</a>. ' +
    "Możesz określić warunki przechowywania lub dostępu do plików cookies w Twojej przeglądarce. "
  var link =
    `<a href="#" class="${classes.button}" id="legal-info-confirm">` +
    "OK, rozumiem" +
    "</a>"
  var cookiePolicyText =
    `<div class="${classes.container}" id="legal-info"><div class="${classes.containerInner}"><div class="${classes.flex}"><div class="${classes.left}"><p class="legal-info__text">` +
    text +
    `</p></div><div class="${classes.right}">` +
    link +
    "</div></div></div></div>"

  const div = document.createElement("div")
  div.innerHTML = cookiePolicyText

  if (document.cookie.indexOf("_legalinfo=true") === -1) {
    document.body.appendChild(div)
    const acceptEl = document.getElementById("legal-info-confirm")
    if (!acceptEl) {
      return false
    }
    acceptEl.addEventListener("click", (e) => {
      e.preventDefault()
      onAccept()
    })
  }

  return true
}
